import { FC } from "react";
import { BrandingSection } from "./components/BrandingSection/BrandingSection";
import { ChatAppearanceSection } from "./components/ChatAppearanceSection/ChatAppearanceSection";

export const AppearanceGeneralTab: FC = () => {
  return (
    <div className="flex flex-col gap-14">
      <BrandingSection />
      <ChatAppearanceSection />
    </div>
  );
};
